import React, { useState } from "react";
import { Redirect, useParams } from "react-router-dom";
import ArticlesList from "../ArticlesList";
import {
  FantasyArticlesCreateButton,
  FantasyArticlesHeader,
  FantasyArticlesTitle,
} from "./styles";
import ArticlesDisplay from "../ArticlesDisplay";
import Button from "../../../Button";
import GroupCheck from "../../../GroupCheck";

export default function BettingArticles() {
  const { sport } = useParams();
  const [searchText, setSearchText] = useState(null);
  const [activeSearch, setActiveSearch] = useState(null);

  const categories = ["betting"];

  if (sport) {
    categories.push(sport.toLowerCase());
  }

  return (
    <>
      <FantasyArticlesHeader>
        <GroupCheck groupName="Content Writer">
          <FantasyArticlesCreateButton href="/article/create">
            New Article
          </FantasyArticlesCreateButton>
        </GroupCheck>
        <FantasyArticlesTitle>
          {sport !== undefined ? sport.toUpperCase() : ""} Betting Articles
        </FantasyArticlesTitle>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            setActiveSearch(searchText);
          }}
        >
          <input
            type="text"
            className="form-input"
            placeholder={`Search${
              sport !== undefined ? " " + sport.toUpperCase() + " " : " "
            }betting articles...`}
            onKeyUp={(e) => {
              setSearchText(e.target.value);
            }}
          />
          <br />
          <br />
          <Button form={true} type="submit">
            Search
          </Button>
        </form>
        <hr />
      </FantasyArticlesHeader>
      <React.Suspense fallback="">
        <ArticlesDisplay activeSearch={activeSearch} categories={categories} />
      </React.Suspense>
    </>
  );
}
